var _rect, _path, _path2, _path3, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97 13.915c-.237.203-.539.291-1.022.291h-.2v-2.422h.2c.483 0 .774.082 1.023.296.257.22.411.56.411.91 0 .354-.154.706-.411.925Zm-.873-2.752H5v3.664h1.09c.581 0 1-.132 1.367-.424a1.81 1.81 0 0 0 .695-1.407c0-1.082-.844-1.833-2.055-1.833ZM8.497 11.163h.744v3.664h-.744v-3.664ZM11.068 12.567c-.45-.157-.58-.262-.58-.46 0-.23.234-.405.557-.405.223 0 .408.086.604.295l.388-.488a1.71 1.71 0 0 0-1.124-.407c-.677 0-1.194.451-1.194 1.048 0 .506.24.763.941 1.007.293.098.442.164.517.21.15.091.224.224.224.377 0 .298-.247.517-.58.517a.887.887 0 0 1-.815-.49l-.482.446c.345.483.757.699 1.326.699.775 0 1.32-.497 1.32-1.204 0-.583-.252-.847-1.102-1.145ZM12.405 12.996c0 1.078.884 1.912 2.022 1.912.321 0 .596-.06.935-.213v-.842c-.3.288-.562.401-.902.401-.752 0-1.285-.52-1.285-1.263 0-.702.55-1.258 1.252-1.258.354 0 .625.12.935.412v-.84a1.978 1.978 0 0 0-.92-.225c-1.13 0-2.037.852-2.037 1.916ZM21.412 13.623l-1.021-2.46h-.815L21.2 14.92h.4l1.655-3.757h-.808l-1.035 2.46ZM23.593 14.827h2.118v-.62h-1.37v-.99h1.318v-.62h-1.318v-.813h1.37v-.62h-2.117v3.663ZM27.17 12.848h-.217V11.74h.229c.466 0 .716.187.716.544 0 .367-.25.564-.729.564Zm1.497-.604c0-.686-.492-1.08-1.354-1.08h-1.11v3.663h.75v-1.473h.097l1.031 1.473H29l-1.205-1.544c.563-.11.872-.478.872-1.039Z",
    fill: "#201D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.682 13.005c0 1.055-.893 1.91-1.996 1.91s-1.996-.855-1.996-1.91.893-1.91 1.996-1.91c1.102 0 1.996.855 1.996 1.91Z",
    fill: "url(#discover_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.682 13.005c0 1.055-.893 1.91-1.996 1.91s-1.996-.855-1.996-1.91.893-1.91 1.996-1.91c1.102 0 1.996.855 1.996 1.91Z",
    fill: "url(#discover_svg__b)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "discover_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-128.1 12.42 2.49) scale(2.62092 2.73884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9D2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#DF7624",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#BF4B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__a",
    x1: 16.461,
    y1: 11.455,
    x2: 18.945,
    y2: 14.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9D2C"
  })))));
};
export default SvgDiscover;